/**
 * Kill rewards outside the gem economy (docs/03, docs/12 rebalance): item
 * drops, crate rarity, pilot XP. Gem payouts are in ECONOMY.
 */
export const LOOT = {
  /** Boss HP fractions (descending) that each roll a shield-plate drop.
   * Wave 4: 2 rolls at 50% (was 3 at 35% — same plates, fewer pickups) */
  shieldThresholds: [0.66, 0.33],
  shieldChance: 0.5,
  /** The plate lands this far from the boss (px) */
  shieldDropRadius: 160,
  /**
   * Minion kill: pilot XP + rare supply drops. Wave 4 halved the odds and
   * doubled the amount (same value, half the pickups): red 0.06×1 →
   * 0.03×2, repair 0.05×25 HP → 0.025×50 HP, armor 0.04×1 → 0.02×2 plates.
   */
  minion: {
    xp: 2,
    redChance: 0.03,
    redValue: 2,
    repairChance: 0.025,
    armorChance: 0.02,
    supplyAmount: 2,
  },
  /** Live repair/armor pickups at once; past this a drop pays its value */
  maxLiveItems: 3,
  /** Yellow value of a drop that would be useless (full hull / full store) */
  itemValue: { repair: 4, armor: 5 },
  /** Yellow paid for scrapping a weapon (also: crates nobody can carry) */
  scrapValue: { common: 6, rare: 10, epic: 16 },
  /**
   * Boss kill pilot XP = base + level * perLevel. Retuned for depth/sector
   * levels (was 30 + 20·lv, which paid ~10 pilot levels per late run):
   * a Sector 1 clear is now ~4 pilot levels, a Sector 4 clear ~2-3.
   */
  bossXp: { base: 40, perLevel: 4 },
  /** One-off pilot XP for winning sector i (its index) */
  sectorClearXp: [120, 180, 240, 300],
  /** Boss yellow payout: at least `bossGemMinBurst` pieces (value split
   * evenly, pieces of ~ECONOMY.gems.pieceValue) */
  bossGemMinBurst: 4,
  /** Boss red payout splits into at least this many pieces */
  bossRedMinBurst: 2,
  /** Boss bonus loot lands this far below the carcass (px) */
  bossDropOffset: 90,
  /** Crate rarity roll: r < epic → epic, r < rare → rare, else common */
  weaponRarity: { epic: 0.1, rare: 0.4 },
} as const;
